module.exports = __webpack_public_path__ + "static/img/extended-insurance-2.996a17d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/my/extended-insurance-2.png
// module id = AiCG
// module chunks = 1